import IS_BROWSER from '../isBrowser/index.js';

function normalizeDomain(domain) {
  if (!domain && IS_BROWSER) {
    var parts = window.location.hostname.split('.');
    if (parts.length >= 3) {
      return parts.slice(-2).join('.');
    }
    return parts.join('.');
  }
  var modifiedDomain = (domain === null || domain === void 0 ? void 0 : domain.startsWith('.')) ? domain.substring(1) : domain;
  return modifiedDomain || '';
}
function setCookie(name, value, domain, path, daysToExpire) {
  if (path === void 0) {
    path = '/';
  }
  if (daysToExpire === void 0) {
    daysToExpire = 365;
  }
  if (!IS_BROWSER) {
    return;
  }
  var date = new Date();
  date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
  document.cookie = "".concat(name, "=").concat(value, ";expires=").concat(date.toUTCString(), ";path=").concat(path, ";domain=").concat(normalizeDomain(domain));
}
function deleteCookie(name, domain, paths) {
  if (paths === void 0) {
    paths = ['/'];
  }
  if (!IS_BROWSER) {
    return;
  }
  var expires = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';
  var normalizedDomain = normalizeDomain(domain);
  var domains = [normalizedDomain, ".".concat(normalizedDomain)];
  for (var _i = 0, paths_1 = paths; _i < paths_1.length; _i++) {
    var path = paths_1[_i];
    for (var _a = 0, domains_1 = domains; _a < domains_1.length; _a++) {
      var domainValue = domains_1[_a];
      document.cookie = "".concat(name, "=;").concat(expires, ";path=").concat(path, ";domain=").concat(domainValue, ";");
    }
  }
}
function getCookie(name) {
  if (!IS_BROWSER) {
    return null;
  }
  var cookieString = document.cookie;
  var cookies = cookieString.split('; ');
  for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
    var cookie = cookies_1[_i];
    var _a = cookie.split('='),
      cookieName = _a[0],
      cookieValue = _a[1];
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
}
function getSSRCookie(cookies, key) {
  var reg = new RegExp("(?:(?:^|.*;\\s*)".concat(key, "\\s*\\=\\s*([^;]*).*$)|^.*$"));
  if (cookies) {
    var result = cookies.replace(reg, '$1');
    return result === cookies || result === '' ? null : result;
  }
  return null;
}

export { deleteCookie, getCookie, getSSRCookie, normalizeDomain, setCookie };
//# sourceMappingURL=index.js.map
